export const errorOperationMap = {
    emptySearchResults: "empty-search-results",
    invalidateCaches: "invalidate-caches",
    resetThread: "reset-thread",
    resolveIndustryTaxonomyOptIn: "resolve-industry-taxonomy-opt-in",
} as const;
